import styled from 'styled-components';
import { motion } from 'framer-motion';

export const TerminalWrapper = styled.section`
  /* Viewport height (100vh) minus the Navbar height (70px) */
  min-height: calc(100vh - 70px); 
  
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  width: 100%;
`;

export const TerminalBox = styled(motion.div)`
  width: 100%;
  max-width: ${props => props.$isExpanded ? '100%' : '800px'};
  height: ${props => props.$isExpanded ? '100%' : '65vh'};
  min-height: 500px;
  
  background-color: #1a1b26; 
  border-radius: ${props => props.$isExpanded ? '0' : '10px'};
  
  position: ${props => props.$isExpanded ? 'fixed' : 'relative'};
  inset: ${props => props.$isExpanded ? '0' : 'auto'};
  z-index: ${props => props.$isExpanded ? '9999' : '1'};
  
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--font-body);
`;

export const TerminalHeader = styled.div`
  display: flex;
  gap: 8px;
  padding: 1rem 1.5rem;
  background-color: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

export const MacButton = styled.div`
  width: 12px; 
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  cursor: ${props => props.$clickable ? 'pointer' : 'default'};
  transition: filter 0.2s;

  &:hover {
    filter: ${props => props.$clickable ? 'brightness(1.3)' : 'none'};
  }
`;

export const TerminalContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: #414868 transparent;
`;

export const CommandLine = styled.div`
  color: #a9b1d6;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
  white-space: pre-wrap;
`;

export const PromptString = styled.span`
  color: #c678dd;
  margin-right: 10px;
  white-space: nowrap;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TerminalInput = styled.input`
  background: transparent;
  border: none;
  color: #a9b1d6;
  font-family: var(--font-body);
  font-size: 0.95rem;
  outline: none;
  flex-grow: 1;
  padding: 0;
  margin: 0;
  
  /* Keeps your custom theme color for the native blinking line */
  caret-color: #7aa2f7; 
`;

export const TapCommand = styled.span`
  color: #7aa2f7;
  cursor: pointer;
  font-weight: bold;
  transition: color 0.2s;

  &:hover {
    color: #00ff9d;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    display: block;
    padding: 0.5rem 0; 
    font-size: 1.05rem;
  }
`;

export const ProjectLink = styled.a`
  color: #9ece6a;
  text-decoration: none;
  display: block;
  margin-top: 0.25rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const OpenTerminalButton = styled(motion.button)`
  padding: 1rem 2rem;
  background-color: transparent;
  color: #7aa2f7;
  border: 1px solid #7aa2f7;
  border-radius: 8px;
  font-family: var(--font-heading);
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(122, 162, 247, 0.1);
    box-shadow: 0 0 15px rgba(122, 162, 247, 0.2);
  }
`;